import { styled } from '@mui/system'

export const Span = styled('span')`
	color: ${({ theme }) => theme.palette.grey.main};
	cursor: pointer;
`
